/**
 * @generated SignedSource<<b3964b00d117bf216285678c130f1972>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerpsPoolAccountFragment$data = {
  readonly address: string;
  readonly strategies: ReadonlyArray<{
    readonly account?: string;
    readonly pool?: {
      readonly address: string;
    };
    readonly " $fragmentSpreads": FragmentRefs<"PerpsPoolBalanceFragment">;
  }>;
  readonly " $fragmentType": "PerpsPoolAccountFragment";
};
export type PerpsPoolAccountFragment$key = {
  readonly " $data"?: PerpsPoolAccountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PerpsPoolAccountFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PerpsPoolAccountFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "strategies",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PerpsPoolBalanceFragment"
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "account",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PerpsPool",
              "kind": "LinkedField",
              "name": "pool",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "PerpsAccount",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Account",
  "abstractKey": null
};
})();

(node as any).hash = "97f034403e392031a4886299fbb9aae6";

export default node;
